import * as actionTypes from "constants/actionTypes";

const initialState = {
  synced: false,
  goals: {}
};

export default function goals(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REPLACE_ACCOUNT_GOALS:
      return {
        synced: true,
        goals: action.payload
      };

    case actionTypes.UPDATE_GOAL_IN_STORE: {
      const { goalId, changes } = action.payload;

      return {
        ...state,
        goals: {
          ...state.goals,
          [action.payload.goalId]: {
            ...state.goals[goalId],
            ...changes
          }
        }
      };
    }

    case actionTypes.DELETE_GOAL_IN_STORE: {
      const {
        [action.payload.goalId]: omit,
        ...stateWithoutGoal
      } = state.goals;
      return { ...state, goals: stateWithoutGoal };
    }

    case actionTypes.CLEAR_ACCOUNT_DATA:
      return initialState;

    default:
      return state;
  }
}

export const selectAccountGoals = state => state.account.goals.goals;
export const selectAccountGoal = (state, goalId) =>
  selectAccountGoals(state)[goalId];
export const selectAccountGoalsSynced = state => state.account.goals.synced;
